<script setup>
import { ref } from 'vue'
import _ from 'lodash'
import TransitionExpand from '@components/global/transitions/TransitionExpand.vue'
import Button from '@components/global/forms/Button.vue'
import Tag from '@components/global/Tag.vue'

const props = defineProps(['service', 'expanded'])
const cards = ref(true)
</script>

<template>
	<div class="select-none">
		<button class="flex w-full cursor-pointer gap-1.5">
			<!-- <div :class="['font-alternate-gothic text-5xl uppercase text-crowns-castle-shadow transition-colors duration-500', { 'text-crowns-off-white': expanded }]">{{ service.name }}</div>
			<div class="flex h-7 w-7 items-center justify-center rounded-full bg-crowns-castle-shadow p-1">{{ service.stamp }}</div> -->
			<h5>{{ service.name }}</h5>
			<div class="mt-1 flex h-5.5 w-5.5 items-center justify-center rounded-full bg-crowns-castle-shadow text-xs font-semibold tracking-tighter text-black">{{ service.stamp }}</div>
		</button>
		<TransitionExpand>
			<div class="mt-5 flex flex-col gap-6" v-if="expanded">
				<p>{{ service.description }}</p>
				<div class="flex gap-5">
					<div :class="['relative flex w-full flex-col gap-8 sm:flex-row sm:gap-0']" v-if="service.showcased_projects.length > 0">
						<div class="flex" @mouseenter="cards = false" @mouseleave="cards = true">
							<router-link v-for="project in _.reverse(service.showcased_projects.slice(0, 4))" :class="['z-10 w-1/3 -rotate-3 object-contain shadow-lg shadow-crowns-off-black transition-all duration-200 ease-in-out md:-rotate-0 md:hover:-rotate-3 md:hover:scale-110 [&:not(:first-child)]:-ml-[11.1%]', { 'sm:odd:-rotate-3 sm:even:rotate-3 sm:[&:not(:first-child)]:-ml-[25%]': cards }]" :to="{ name: 'project', params: { slug: project.slug } }">
								<img class="h-full w-full object-cover object-center" :src="project.poster" :alt="`${project.name} Poster`" />
							</router-link>
						</div>
						<div class="right-0 top-0 z-0 flex h-full items-center sm:absolute md:w-1/3 md:justify-center">
							<Button type="underline" label="View More" :to="{ name: 'work' }" />
						</div>
					</div>
				</div>
				<div class="flex flex-wrap gap-1.5" v-if="service.showcased_services.length > 0">
					<Tag v-for="tag in service.showcased_services">{{ tag.name_short ?? tag.name }}</Tag>
				</div>
				<!-- <img src="https://cdn.papercrowns.com/website/images/elements/accents/hr-med.svg" alt="" /> -->
				<svg class="w-full" viewBox="0 0 456 7" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M0.27084 6.62712C3.12366 6.62712 5.97649 6.62712 8.82931 6.65225C15.0586 6.71509 21.3239 7.1172 27.5171 6.96641C37.4658 6.71509 47.3785 5.91085 57.3273 5.76006C69.0997 5.57157 80.7457 4.75476 92.6445 4.96839C106.042 5.19458 119.53 4.31495 132.981 4.0385C150.477 3.67408 167.991 3.47302 185.488 3.13373C189.315 3.05834 193.125 2.65623 198.686 2.30438C199.427 2.4803 201.521 3.38505 203.652 3.38505C216.652 3.44788 229.652 3.23426 242.634 3.25939C254.244 3.27196 265.908 3.15886 277.428 3.66151C297.163 4.52857 316.79 4.76733 336.47 3.61124C343.584 3.19656 350.843 2.51799 357.903 2.75675C371.21 3.19656 384.282 1.78916 397.77 2.58082C414.851 3.57355 432.275 3.2971 449.572 3.41019C451.703 3.42276 453.869 2.41747 456 1.87712C453.996 1.27395 452.046 0.193264 449.987 0.142999C440.58 -0.0580586 431.137 0.0173332 421.712 0.0298993C406.888 0.0424654 392.046 -0.108327 377.258 0.168127C351.655 0.64564 326.088 1.81429 300.503 1.92739C276.038 2.02792 251.554 0.75874 227.088 0.771306C193.143 0.796438 159.198 1.43731 125.253 1.83942C105.229 2.07818 85.2235 2.35463 65.2177 2.66878C47.0716 2.95781 28.9435 3.32223 10.7974 3.68665C8.01679 3.74948 5.2362 4.30238 2.50977 4.20185C1.6792 4.17672 0.830568 4.13903 0 4.08876C0.0902791 4.93069 0.180561 5.78519 0.27084 6.62712Z"
						fill="#1B1B1B" />
				</svg>
			</div>
		</TransitionExpand>
	</div>
</template>
